import { create } from "zustand";

type CommercialState = {
  emisorId: number | null;
  setEmisorId: (id: number | null) => void;
};

const initial = Number(localStorage.getItem("inpronexus.commercial.emisor_id"));

export const useCommercialStore = create<CommercialState>((set) => ({
  emisorId: Number.isFinite(initial) && initial > 0 ? initial : null,
  setEmisorId: (emisorId) => {
    if (emisorId) {
      localStorage.setItem("inpronexus.commercial.emisor_id", String(emisorId));
    } else {
      localStorage.removeItem("inpronexus.commercial.emisor_id");
    }
    set({ emisorId });
  },
}));
